import RestUtility from '../../restUtility';
import { ClamShellTemplate, Coordinates, TemplateServerResponse } from 'types';

import { customClamshellDesignEndPoint } from '../../restUtility/restEndpoints';
import { notifyError } from 'config/setupBugsnag';

export class CustomClamshellService {
  private restUtility: RestUtility;
  constructor() {
    this.restUtility = new RestUtility();
  }

  async getCustomTemplates() {
    try {
      const response = await this.restUtility.get<{
        data: TemplateServerResponse[];
      }>(`${customClamshellDesignEndPoint}`);

      return this.buildTemplatesForClient(response.data);
    } catch (error) {
      notifyError('ApiError:: getCustomTemplates', error);
      throw error;
    }
  }

  async createTemplate(
    templateName: string,
    logoImage: Blob | undefined,
    qrcodeImage: Blob | undefined,
    previewImage: Blob | undefined,
    webUrl: string,
    qrcodeText: string,
    logo_coordinates: Coordinates | undefined,
    web_url_coordinates: Coordinates | undefined,
    qrcode_coordinates: Coordinates | undefined
  ) {
    try {
      if (
        logoImage &&
        previewImage &&
        qrcodeImage &&
        logo_coordinates &&
        web_url_coordinates &&
        qrcode_coordinates
      ) {
        const data = new FormData();
        data.append('design[name]', templateName);
        data.append('design[logo_url]', logoImage, 'logo.png');
        data.append('design[preview_url]', previewImage, 'preview.png');
        data.append('design[qr_code_url]', qrcodeImage, 'qr_code.png');
        data.append(
          'design[logo_coordinates]',
          JSON.stringify(logo_coordinates)
        );
        data.append(
          'design[web_url_coordinates]',
          JSON.stringify(web_url_coordinates)
        );
        data.append('design[qr_code_text]', qrcodeText);
        data.append('design[website_url]', webUrl);
        data.append(
          'design[qr_code_coordinates]',
          JSON.stringify(qrcode_coordinates)
        );

        return await this.restUtility.post<{
          data: TemplateServerResponse;
          msg: string;
          success: boolean;
        }>(`${customClamshellDesignEndPoint}`, data);
      } else {
        throw new Error(' Invalid Parameters');
      }
    } catch (error) {
      notifyError('ApiError:: createTemplate', error);
      throw error;
    }
  }

  async updateTemplate(
    templateCode: string,
    templateName: string,
    logoImage: Blob | undefined,
    qrcodeImage: Blob | undefined,
    previewImage: Blob | undefined,
    webUrl: string,
    qrcodeText: string,
    logo_coordinates: Coordinates | undefined,
    web_url_coordinates: Coordinates | undefined,
    qrcode_coordinates: Coordinates | undefined
  ) {
    console.log('templateCode', templateCode);
    console.log('logoImage', logoImage);
    console.log('logo_coordinates', logo_coordinates);
    try {
      if (
        templateCode &&
        logoImage &&
        previewImage &&
        qrcodeImage &&
        // logo_coordinates &&
        web_url_coordinates &&
        qrcode_coordinates
      ) {
        const data = new FormData();
        data.append('design[name]', templateName);
        data.append('design[logo_url]', logoImage, 'logo.png');
        data.append('design[preview_url]', previewImage, 'preview.png');
        data.append('design[qr_code_url]', qrcodeImage, 'qrcode.png');
        data.append(
          'design[logo_coordinates]',
          JSON.stringify(logo_coordinates)
        );
        data.append(
          'design[web_url_coordinates]',
          JSON.stringify(web_url_coordinates)
        );
        data.append('design[qr_code_text]', qrcodeText);
        data.append('design[website_url]', webUrl);
        data.append(
          'design[qr_code_coordinates]',
          JSON.stringify(qrcode_coordinates)
        );
        return await this.restUtility.put<{ data: TemplateServerResponse }>(
          `${customClamshellDesignEndPoint}/${templateCode}`,
          data
        );
      } else {
        throw new Error(' Invalid Parameters');
      }
    } catch (error) {
      notifyError('ApiError:: updateTemplate', error);
      throw error;
    }
  }

  async deleteTemplate(templateCode: string) {
    try {
      return await this.restUtility.delete(
        `${customClamshellDesignEndPoint}/${templateCode}`
      );
    } catch (error) {
      notifyError('ApiError:: deleteTemplate', error);
      throw error;
    }
  }

  async cloneTemplate(templateId: string) {
    return null;
  }

  async getCustomTemplateById(templateId: string | null | undefined) {
    try {
      if (templateId) {
        const response = await this.restUtility.get<{
          data: TemplateServerResponse;
        }>(`${customClamshellDesignEndPoint}/${templateId}`);

        return this.buildTemplateForClient(response.data);
      } else {
        return undefined;
      }
    } catch (error) {
      notifyError('ApiError:: getCustomTemplateById', error);
      throw error;
    }
  }

  buildTemplatesForClient(response: TemplateServerResponse[]) {
    const clamshellTemplates: ClamShellTemplate[] = [];

    for (let i = 0; i < response.length; i++) {
      const template = response[i];
      clamshellTemplates.push(this.buildTemplateForClient(template));
    }

    return clamshellTemplates;
  }

  buildTemplateForClient(template: TemplateServerResponse) {
    return {
      code: template.code,
      name: template.name,
      webUrl: template.website_url,
      qrcodeText: template.qr_code_text,
      previewUrl: template.preview_url,
      logoUrl: template.logo_url,
      qrCodeUrl: template.qr_code_url,
      status: template.status,
      logoCoordinates: template.logo_coordinates,
      webUrlCoordinates: template.web_url_coordinates,
      qrcodeCoordinates: template.qr_code_coordinates,
      has_orders: template.has_orders,
    };
  }
}
